/**
 * Clipboard utility with fallback for iframe/permission-restricted environments.
 */
export async function copyToClipboard(text) {
  try {
    await navigator.clipboard.writeText(text)
    return true
  } catch {
    // Fallback: textarea + execCommand
    const ta = document.createElement('textarea')
    ta.value = text
    ta.style.cssText = 'position:fixed;left:-9999px;top:-9999px'
    document.body.appendChild(ta)
    ta.select()
    try { document.execCommand('copy'); return true }
    catch { return false }
    finally { document.body.removeChild(ta) }
  }
}
